// extracted by mini-css-extract-plugin
module.exports = {"GlobalNum1":"GlobalNum1_GlobalNum1__45oaj"};